/**
 * Das Gewand.
 *
 * Zwei vollständige Entwürfe auf einer Codebasis: „Gerichtssaal bei Nacht"
 * (Vorgabe) und „Kanzleiakte". Der Unterschied steckt vollständig in den
 * Tokens und drei Bauteilen — die Screens wissen davon nichts.
 *
 * Gesetzt wird es beim Bauen über VITE_THEMA, damit jede Instanz ihr eigenes
 * Gewand trägt. Zusätzlich darf jede Person es für sich umstellen; das gilt
 * dann nur auf ihrem Gerät.
 */

export type Thema = 'gerichtssaal' | 'kanzlei'

const SPEICHER_KEY = 'strschgb.thema'

/** Das beim Bauen festgelegte Gewand dieser Instanz. */
export function gebautesThema(): Thema {
  return import.meta.env.VITE_THEMA === 'kanzlei' ? 'kanzlei' : 'gerichtssaal'
}

export function aktuellesThema(): Thema {
  const gewaehlt = localStorage.getItem(SPEICHER_KEY)
  if (gewaehlt === 'kanzlei' || gewaehlt === 'gerichtssaal') return gewaehlt
  return gebautesThema()
}

export function setzeThema(thema: Thema): void {
  localStorage.setItem(SPEICHER_KEY, thema)
  wendeThemaAn(thema)
}

/** Schreibt das Gewand an die Wurzel — die CSS-Tokens hängen daran. */
export function wendeThemaAn(thema: Thema = aktuellesThema()): void {
  document.documentElement.dataset.thema = thema
  const farbe = thema === 'kanzlei' ? '#1a130d' : '#150e0f'
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', farbe)
}
